// UpdatePromise.jsx - Always in Sync (Reassurance, not hype)
import React from 'react';
import './UpdatePromise.css';

const BULLETS = [
  'New models added fast',
  'New workflows shipped weekly',
  'Request a model or workflow — we prioritize it',
];

const SOTA_MODELS = [
  'GPT Image',
  'Nano Banana',
  'SeeDream',
];

const UpdatePromise = () => {
  return (
    <section className="landing-section update-section">
      <h2 className="section-title">Always in sync with what's next</h2>
      <p className="update-copy">
        We add the latest models and trends as soon as they drop.
      </p>

      <ul className="update-bullets">
        {BULLETS.map((text, index) => (
          <li key={index} className="update-bullet">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="20,6 9,17 4,12" />
            </svg>
            {text}
          </li>
        ))}
      </ul>

      <div className="recent-additions">
        <span className="additions-label">Sota models Available</span>
        <div className="additions-pills">
          {SOTA_MODELS.map((model, index) => (
            <span key={index} className="addition-pill">{model}</span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UpdatePromise;
